
import React from 'react';
import { getWhatsAppUrl } from '../config/constants';
import './ServicesGrid.css';

const services = [
  {
    id: 1,
    title: 'Bodas',
    description: 'El día más especial merece recuerdos únicos',
    image: 'https://cdn.abacus.ai/images/fd75dbba-7da1-4ef8-96a8-db6d7a9e7d78.png',
    buttonText: '¡Quiero mi cotización!',
  },
  {
    id: 2,
    title: 'XV Años',
    description: 'Tu fiesta de XV será inolvidable',
    image: 'https://cdn.abacus.ai/images/b55219e6-8aee-48b6-910b-18b0b53f8821.png',
    buttonText: '¡Haz mi evento épico!',
  },
  {
    id: 3,
    title: 'Cumpleaños',
    description: 'Celebra con estilo y diversión',
    image: 'https://cdn.abacus.ai/images/b6279984-1feb-4791-8012-8bc81c1df55d.png',
    buttonText: '¡Quiero recuerdos 360!',
  },
  {
    id: 4,
    title: 'Corporativos',
    description: 'Eventos profesionales con un toque especial',
    image: 'https://cdn.abacus.ai/images/024cb48b-a010-4c31-a9be-9fa0f27e3e3d.png',
    buttonText: '¡Cotiza tu evento!',
  },
];

function ServicesGrid() {
  const handleWhatsApp = (service) => {
    window.open(
      getWhatsAppUrl(`¡Hola! Me interesa cotizar para mi evento de ${service}`),
      '_blank'
    );
  };

  return (
    <section className="services-grid section">
      <div className="container">
        <h2>Nuestros Servicios</h2>
        <p className="services-subtitle">¡Haz que todos hablen de tu fiesta!</p>

        <div className="grid">
          {services.map((service) => (
            <div key={service.id} className="service-card card">
              <div
                className="service-image"
                style={{ backgroundImage: `url(${service.image})` }}
              >
                <div className="overlay">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <button
                    className="btn btn-primary btn-glow"
                    onClick={() => handleWhatsApp(service.title)}
                  >
                    {service.buttonText}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServicesGrid;
